export const goodsInfocolumnT = [
  // { col: "货物编码", prop: "goodsCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物名称", prop: "goodsName", mergeRow: false, width: null, fixed: false },
  { col: "货物名称/编码", prop: "goodsNameCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物品类代码", prop: "goodsCategoryCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物品类名称", prop: "goodsCategoryName", mergeRow: false, width: null, fixed: false }, 
  { col: "品类名称/编码", prop: "goodsCategoryNameCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物种类代码", prop: "goodsTypeCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物种类名称", prop: "goodsTypeName", mergeRow: false, width: null, fixed: false },
  { col: "种类名称/编码", prop: "goodsTypeNameCode", mergeRow: false, width: null, fixed: false },
  { col: "计量单位", prop: "calculateUnitStr", mergeRow: false, width: null, fixed: false },
  { col: "货物数量", prop: "quantity", mergeRow: false, width: null, fixed: false },
  { col: "计价单位", prop: "pricingUnitStr", mergeRow: false, width: null, fixed: false },
  { col: "单价", prop: "univalent", mergeRow: false, width: null, fixed: false },
  { col: "增值服务", prop: "driverServiceStrList", mergeRow: true, width: 280, fixed: false },
  { col: "操作类型", prop: "operateTypeStr", mergeRow: true, width: 120, fixed: false }, //operateType  1货主计划数据；2货主实际数据；3司机操作数据（出弹框）；
  { col: "提货单版本号", prop: "version", mergeRow: true, width: 120, fixed: false }
];
export const goodsInfocolumnS = [
  // { col: "货物编码", prop: "goodsCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物名称", prop: "goodsName", mergeRow: false, width: null, fixed: false },
  { col: "货物名称/编码", prop: "goodsNameCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物品类代码", prop: "goodsCategoryCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物品类名称", prop: "goodsCategoryName", mergeRow: false, width: null, fixed: false }, 
  { col: "品类名称/编码", prop: "goodsCategoryNameCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物种类代码", prop: "goodsTypeCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物种类名称", prop: "goodsTypeName", mergeRow: false, width: null, fixed: false },
  { col: "种类名称/编码", prop: "goodsTypeNameCode", mergeRow: false, width: null, fixed: false },
  { col: "计量单位", prop: "calculateUnitStr", mergeRow: false, width: null, fixed: false },
  { col: "货物数量", prop: "quantity", mergeRow: false, width: null, fixed: false },
  { col: "计价单位", prop: "pricingUnitStr", mergeRow: false, width: null, fixed: false },
  { col: "单价", prop: "univalent", mergeRow: false, width: null, fixed: false },
  { col: "增值服务", prop: "driverServiceStrList", mergeRow: true, width: 280, fixed: false },
  { col: "操作类型", prop: "operateTypeStr", mergeRow: true, width: 120, fixed: false },
  { col: "送货单版本号", prop: "version", mergeRow: true, width: null, fixed: false }
];
export const goodsInfocolumnTview = [
  // { col: "货物编码", prop: "goodsCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物名称", prop: "goodsName", mergeRow: false, width: null, fixed: false },
  { col: "货物名称/编码", prop: "goodsNameCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物品类代码", prop: "goodsCategoryCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物品类名称", prop: "goodsCategoryName", mergeRow: false, width: null, fixed: false }, 
  { col: "品类名称/编码", prop: "goodsCategoryNameCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物种类代码", prop: "goodsTypeCode", mergeRow: false, width: null, fixed: false },
  // { col: "货物种类名称", prop: "goodsTypeName", mergeRow: false, width: null, fixed: false },
  { col: "种类名称/编码", prop: "goodsTypeNameCode", mergeRow: false, width: null, fixed: false },
  { col: "计量单位", prop: "calculateUnitStr", mergeRow: false, width: null, fixed: false },
  { col: "计价单位", prop: "pricingUnitStr", mergeRow: false, width: null, fixed: false },
  { col: "单价", prop: "univalent", mergeRow: false, width: null, fixed: false },
  { col: "货物数量", prop: "quantity", mergeRow: false, width: 160, fixed: false },
  // { col: "增值服务", prop: "driverServiceStrList", mergeRow: true, width: 280, fixed: false }
];
export const logcolumnT = [
  { col: "提货单号", prop: "goodsOrderId", mergeRow: true, width: null, fixed: false },
  { col: "提货单版本号", prop: "version", mergeRow: false, width: null, fixed: false },
  { col: "操作类型", prop: "operateType", mergeRow: false, width: null, fixed: false },
  { col: "操作内容", prop: "operateContent", mergeRow: false, width: null, fixed: false },
  { col: "操作人", prop: "operator", mergeRow: false, width: null, fixed: false }, 
  { col: "操作时间", prop: "operateTm", mergeRow: false, width: null, fixed: false },
];
export const logcolumnS = [
  { col: "送货单号", prop: "goodsOrderId", mergeRow: true, width: null, fixed: false },
  { col: "送货单版本号", prop: "version", mergeRow: false, width: null, fixed: false },
  { col: "操作类型", prop: "operateType", mergeRow: false, width: null, fixed: false },
  { col: "操作内容", prop: "operateContent", mergeRow: false, width: null, fixed: false },
  { col: "操作人", prop: "operator", mergeRow: false, width: null, fixed: false }, 
  { col: "操作时间", prop: "operateTm", mergeRow: false, width: null, fixed: false },
];